import { Skeleton } from "primereact/skeleton";
import AuthContext from "../../../../auth/AuthContext";
import { useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import AssessmentMasterService from "../../../../services/AssessmentMasterService";
import AlertService from "../../../../services/AlertService";
import AssessmentTypeCard from "./AssessmentTypeCard";
import UserMapCard from "./UserMapCard";

const AssessmentTypes = () => {
  const { state } = useLocation();
  const { assessmentName } = useParams();
  const storedId = sessionStorage.getItem("assessmentId");
  const id = state?.id || storedId;

  const [loading, setLoading] = useState(false);
  const [assessmentTypes, setAssessmentTypes] = useState([]);

  const authContext = useContext(AuthContext);

const loadAssessments = useCallback(async (signal) => { 
    setLoading(true);
    setAssessmentTypes([]);
    try {
      const data = await AssessmentMasterService.GetTypes(
        id,
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        setAssessmentTypes(data.data || []);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, [id, authContext]);

useEffect(() => {
    const controller = new AbortController(); 
    if (id) {
      loadAssessments(controller.signal);
    }
    return () => controller.abort();
  }, [loadAssessments, id]);

  return (
    <div className="container-fluid custom-container mt-3 pt-3">
      <div className="row g-4 mb-4 pt-3">
        {loading ? (
          // Skeletons when loading
          Array.from({ length: 8 }).map((_, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
              <div
                className="card border-0 shadow-sm p-3 p-lg-4 h-100"
                style={{ minHeight: "260px" }}
              >
                <center className="d-flex justify-content-center text-center fw-bold w-100 mb-3">
                  <Skeleton width="50%" height="1.5rem" />
                </center>
                <center className="d-flex justify-content-center text-center fw-bold w-100 mb-2">
                  <Skeleton width="90%" height="1.2rem" />
                </center>
                <center className="d-flex justify-content-center text-center fw-bold w-100 mb-3">
                  <Skeleton width="80%" height="1.2rem" />
                </center>
                <div className="progress mb-3" style={{ height: "5px" }}>
                  <Skeleton width="100%" height="5px" />
                </div>
                <div className="d-flex justify-content-between mb-4">
                  <Skeleton width="20%" height="1.2rem" />
                  <Skeleton width="30%" height="1.2rem" />
                </div>
                <div className="d-flex justify-content-between mb-4">
                  <Skeleton width="20%" height="1.2rem" />
                  <Skeleton width="20%" height="1.2rem" />
                </div>
                <div className="d-flex justify-content-center mb-1">
                  <Skeleton width="80%" height="2rem" borderRadius="20px" />
                </div>
              </div>
            </div>
          ))
        ) : (
          <>


            {assessmentTypes.length > 0 ? (
              assessmentTypes.map((assessment, i) => (
                <div
                  key={i}
                  className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                >
                  <AssessmentTypeCard data={assessment} no={i} />
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-5">
                <h5 className="text-muted">No assessment types available...</h5>
              </div>
            )}
                        <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
              <UserMapCard assessmentId={id} assessmentName={assessmentName}/>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AssessmentTypes;